import React from "react";
import { useNavigate } from "react-router-dom";
import Button from '../components/Button';

export default function ValoracionDisfagia() {
  const navigate = useNavigate();

  return (
    <div className="p-4 max-w-xl mx-auto flex flex-col gap-4">

      {/* Encabezado */}
      <div className="flex items-center justify-center">
        <h3 className="font-bold text-center">VALORACIÓN DISFAGIA</h3>
      </div>

      {/* Recetas */}

      <div className="flex flex-col gap-4 mt-2 font-semibold text-white">
        <Button onClick={() => navigate("/valoracion-disfagia/diagnostico-disfagia-orofaringea")}>
          Usuario/a con diagnóstico de disfagia orofaríngea
        </Button>

        <Button onClick={() => navigate("/valoracion-disfagia/sospecha-disfagia-orofaringea")}>
          Usuario/a con sospecha de disfagia orofaríngea
        </Button>
      </div>
    </div>
  );
}